export const AVAILABLE_MEASUREMENTS = [
  ['weight'],
  ['chest'],
  ['arm', 'rightarm'],
  ['waist'],
  ['hip'],
  ['thigh', 'rightthigh'],
  ['bodyFat'],
  ['muscleMass'],
  ['visceralFat'],
];
